import { render, staticRenderFns } from "./30.vue?vue&type=template&id=49779c23&scoped=true&"
var script = {}
import style0 from "./30.vue?vue&type=style&index=0&id=49779c23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49779c23",
  null
  
)

export default component.exports